import React, { useContext, useEffect, useRef, useState } from 'react';
import { ErrorMessage, Formik, Form, Field } from 'formik';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Fieldset } from 'primereact/fieldset';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from '@material-ui/core';
import { Messages } from 'primereact/messages';
import Context from '../context/form-context';
import { ptBR } from '../../../modulos/schemaDate';
import { optionsSexo } from '../helpers/funcoesAuxiliares';
import { validacoesPrimariasFormDependentes } from '../helpers/yupValidations';
import { DataTableDependentes } from './DataTableDependentes.jsx';
import { DataTableDependentesUpSell } from './DataTableDependentesUpSell.jsx';
import useAlterarCaracteristicasBotoes from '../../../hooks/useAlterarCaracteristicasBotoes';
import { cadastrarDependenteController, editarDependenteController } from '../infraestrutura/infraestrutura';
import { IdadeDependente } from './IdadeDependente.jsx';
import { FormPet } from './FormPet.jsx';
import { showSticky } from '../helpers/mensagensCustomizadas';
import { MsgsValicaoesPlano } from './MsgsValidacoesPlano.jsx';
import { regrasPorPlanoValidateOnSubmit } from '../regrasPorPlanoOnSubmit';
import { FormValor } from './FormValor.jsx';
import Loading from '../../loading/index.js';
import ModalSweet from '../../modal/index.jsx';

export const FormDependentes = () => {
    const cartaoCredito = 7;
    const messages = useRef(null);
    const { state, setState } = useContext(Context);
    const [modalVisible, setModalVisible] = useState(false);
    const [existePagador, setExistePagador] = useState(false);
    const [isDisabled, setIsDisabled] = useState(existePagador);
    const [isUpSell, setIsUpSell] = useState(false);
    const {
        plano,
        parentesco,
        categorias,
        editar,
        dependentes,
        inscricao,
        temErroPorPlano,
        subGrupoSelecionadoUpSell,
        Seq,
        tipoCobranca
    } = state;

    const isRecorrente = tipoCobranca === cartaoCredito;

    useEffect(() => {
        setIsUpSell(!!subGrupoSelecionadoUpSell);

        const pagadorExistente = dependentes.some(dependente => dependente.Pagador);

        setExistePagador(pagadorExistente);
        setIsDisabled(pagadorExistente);
    }, [dependentes]);

    const handleEditClick = isPagador => {
        setIsDisabled(isPagador ? false : existePagador);
    };

    const handleSubmit = async (values, actions) => {
        let respostaTela;
        let detalhes = '';

        const arrayMsgErro = await regrasPorPlanoValidateOnSubmit(dependentes, plano.trim(), values, editar);

        if (values?.Parentesco?.toUpperCase() === 'PET') {
            values.Pagador = false;
        }

        if (arrayMsgErro.length > 0) {
            setState({
                ...state,
                arrayMsgsValidacoesPlano: arrayMsgErro,
                temErroPorPlano: false
            });

            return false;
        }

        if (editar) {
            respostaTela = await editarDependenteController(values, inscricao, subGrupoSelecionadoUpSell, Seq);
            detalhes = 'Edição do dependente realizada com sucesso';
        } else {
            respostaTela = await cadastrarDependenteController(values, inscricao, subGrupoSelecionadoUpSell);
            detalhes = 'Cadastro do dependente realizado com sucesso';
        }

        if (respostaTela.sucesso) {
            actions.resetForm();
            showSticky(messages, 'success', 'Tudo certo!', detalhes, false);
            setState({
                ...state,
                dependentes: [],
                arrayMsgsValidacoesPlano: [],
                recarregarTabelaDependentes: true,
                editar: false
            });
        } else {
            showSticky(messages, 'error', 'Algo deu errado..', respostaTela.mensagem, true);
        }
    };

    const { caracteristicasBotaoSubmit, caracteristicasBotaoLimpar } = useAlterarCaracteristicasBotoes(editar);

    return (
        <>
            <Formik
                onSubmit={handleSubmit}
                initialValues={{
                    Nome: '',
                    Telefone: '',
                    CPF: '',
                    Email: '',
                    DepSexo: '',
                    Categoria: '',
                    Parentesco: '',
                    Idade: '',
                    Nascimento: null,
                    TipoPet: null,
                    CaracteristicasPet: '',
                    PesoPet: null,
                    showPetForm: false,
                    Porte: null,
                    CorPet: '',
                    ValorDependente: null,
                    Plano: plano.trim(),
                    Pagador: false
                }}
                validationSchema={validacoesPrimariasFormDependentes}>

                {({ handleBlur, setValues, isSubmitting, setFieldValue, values }) => (
                    !tipoCobranca ? (<Loading />
                    ) : (
                        <Form className="form-ocupar-todo-espaco">
                            <Fieldset legend="Dependentes">
                                <div className="p-grid p-fluid">
                                    {(isRecorrente && !isUpSell) || values.Pagador ? (
                                        <div className="p-col-12">
                                            <div>
                                                <Field
                                                    as={Checkbox}
                                                    name="Pagador"
                                                    id="Pagador"
                                                    color="primary"
                                                    checked={values.Pagador}
                                                    onChange={e => {
                                                        const checked = e.target.checked;

                                                        setFieldValue('Pagador', checked);
                                                        checked ? setModalVisible(true) : setModalVisible(false);
                                                    }}
                                                    disabled={isDisabled}
                                                />
                                                <label className="p-checkbox-label">
                                                    Titular do Cartão de Crédito
                                                </label>
                                                <ErrorMessage
                                                    name="Pagador"
                                                    component="div"
                                                    className="error-message"
                                                    style={{ color: 'red' }}
                                                />
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="p-col-12 p-md-9">
                                        <Field
                                            as={InputText}
                                            name="Nome"
                                            type="text"
                                            id="Nome"
                                            placeholder="Nome"
                                            onChange={e => {
                                                setFieldValue('Nome', e.target.value.toUpperCase());
                                            }}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Nome"
                                            style={{ color: 'red' }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-3">
                                        <Field
                                            as={InputMask}
                                            name="Telefone"
                                            mask="(99) 99999-9999"
                                            placeholder="Celular"
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Telefone"
                                            style={{ color: 'red' }}
                                        />
                                    </div>
                                </div>

                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-4">
                                        <Field
                                            as={InputMask}
                                            id="CPF"
                                            name="CPF"
                                            mask="999.999.999-99"
                                            placeholder="CPF"
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="CPF"
                                            style={{ color: 'red' }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-2">
                                        <div className="p-inputgroup">
                                            <div
                                                className="p-inputgroup-addon"
                                                style={{
                                                    backgroundColor: '#E1E1E1',
                                                    borderColor: 'gray',
                                                    color: 'gray',
                                                    width: '50px',
                                                    height: '33px'
                                                }}>
                                                <i className="pi pi-calendar" />
                                            </div>
                                            <Field
                                                name="Nascimento"
                                                id="Nascimento"
                                                placeholder="Nascimento"
                                                key="calendar"
                                                as={Calendar}
                                                locale={ptBR}
                                                monthNavigator
                                                dateFormat='dd/mm/yy'
                                                maxDate={new Date()}
                                                yearNavigator
                                                yearRange={`1900:${new Date().getFullYear()}`}
                                            />
                                        </div>
                                        <ErrorMessage
                                            component="span"
                                            name="Nascimento"
                                            style={{ color: 'red' }}
                                        />
                                    </div>
                                    <IdadeDependente handleBlur={handleBlur} Messages={messages} />
                                    <div className="p-col-12 p-md-3">
                                        <Field
                                            as={Dropdown}
                                            dataKey="value"
                                            name="DepSexo"
                                            id="DepSexo"
                                            options={optionsSexo}
                                            placeholder="Selecione o sexo"
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="DepSexo"
                                            style={{ color: 'red' }}
                                        />
                                    </div>
                                </div>

                                <div className="p-grid p-fluid">
                                    <div className="p-col-12 p-md-4">
                                        <Field
                                            name="Email"
                                            id="Email"
                                            type="text"
                                            as={InputText}
                                            placeholder="Email"
                                            onChange={e => setFieldValue('Email', e.target.value.toUpperCase())}
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Email"
                                            style={{ color: 'red' }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-4">
                                        <Field
                                            as={Dropdown}
                                            dataKey="value"
                                            name="Parentesco"
                                            id="Parentesco"
                                            options={parentesco}
                                            placeholder="Selecione o parentesco"
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Parentesco"
                                            style={{ color: 'red' }}
                                        />
                                    </div>
                                    <div className="p-col-12 p-md-4">
                                        <Field
                                            as={Dropdown}
                                            name="Categoria"
                                            id="Categoria"
                                            dataKey="value"
                                            options={categorias}
                                            placeholder="Selecione o valor"
                                        />
                                        <ErrorMessage
                                            component="span"
                                            name="Categoria"
                                            style={{ color: 'red' }}
                                        />
                                    </div>
                                    <FormPet />
                                    <FormValor plano={plano.trim()} />
                                </div>
                            </Fieldset>
                            <div className="p-grid p-fluid div-acoes-form">
                                <div className="p-col-6 p-md-3 p-lg-3 btn-mobile">
                                    <Field
                                        as={Button}
                                        name="BtnSubmit"
                                        label={caracteristicasBotaoSubmit.label}
                                        type="submit"
                                        icon={caracteristicasBotaoSubmit.icon}
                                        iconPos="left"
                                        disabled={isSubmitting || temErroPorPlano}
                                        className={caracteristicasBotaoSubmit.className}
                                    />
                                </div>
                                <div className="p-col-6 p-md-3 p-lg-3 btn-mobile">
                                    <Field
                                        as={Button}
                                        label={caracteristicasBotaoLimpar.label}
                                        type="reset"
                                        icon={caracteristicasBotaoLimpar.icon}
                                        iconPos="left"
                                        disabled={isSubmitting}
                                        className={caracteristicasBotaoLimpar.className}
                                        onClick={() => {
                                            setState({
                                                ...state,
                                                arrayMsgsValidacoesPlano: [],
                                                editar: false
                                            });
                                            handleEditClick(false);
                                        }}
                                    />
                                </div>
                                <div className="p-col-6 btn-mobile">
                                    <MsgsValicaoesPlano />
                                </div>
                                <div className="p-col-6 btn-mobile">
                                    <Messages
                                        className="p-messages p-messages-wrapper"
                                        ref={messages}
                                    ></Messages>
                                </div>
                            </div>
                            {subGrupoSelecionadoUpSell ? (
                                <DataTableDependentesUpSell
                                    carregarCamposFormulario={setValues}
                                    estaSubmetendo={isSubmitting}
                                />
                            ) : (
                                <DataTableDependentes
                                    carregarCamposFormulario={setValues}
                                    estaSubmetendo={isSubmitting}
                                    dependentePagador={handleEditClick}
                                />
                            )}
                        </Form>
                    )
                )}

            </Formik>
            {modalVisible && (
                <ModalSweet
                    exibiModal={true}
                    title={'Atenção'}
                    html={'Este dependente será o responsável pelo pagamento do plano.<br />Os campos CPF, EMAIL e TELEFONE devem ser preenchidos.'}
                    confirmButtonColor='green'
                    confirmButtonText='Estou Ciente'
                    icon='info'
                />
            )}
        </>
    );
};
